import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import RegisterPromissory from './RegisterPromissory';
import { newAlert } from '../../../actions/alert_actions';
import {
  persistFinancing,
  toggleBaseErrorModal,
  clearFinancing,
  setNextStep,
  fetchGlobalParameters
} from '../../../actions/portal_financing_actions';
import {
  resetStepper,
  setSteps,
  setOptionalSteps,
  persistStepper,
  setCurrentStep
} from '../../../actions/stepper_actions';

function mapStateToProps(state) {
  const pf = state.portalFinancing;
  return {
    routes: state.stepper.routes,
    skips: state.stepper.skippedSteps,
    process: state.stepper.process,
    promissoryNext: state.stepper.promissoryNext,
    loadingParameters: state.requestState.requestFetchGlobalParametersSend,
    globalParameters: {
      validateSaleInvoices: pf.validate_sale_invoices,
      validatePromissoryInvoices: pf.validate_promissory_invoices
    },
    currentUser: state.authentication.currentUser,
    server_errors: pf.errors,
    baseErrorOpen: pf.baseErrorOpen,
    baseErrorText: pf.baseErrorText,
    baseErrorTitle: pf.baseErrorTitle,
    baseErrorRoute: pf.baseErrorRoute
  };
}

function mapDispatchToProps(dispatch) {
  return {
    persistFinancing: bindActionCreators(persistFinancing, dispatch),
    resetStepper: bindActionCreators(resetStepper, dispatch),
    setSteps: bindActionCreators(setSteps, dispatch),
    setOptionalSteps: bindActionCreators(setOptionalSteps, dispatch),
    persistStepper: bindActionCreators(persistStepper, dispatch),
    toggleBaseErrorModal: bindActionCreators(toggleBaseErrorModal, dispatch),
    clearFinancing: bindActionCreators(clearFinancing, dispatch),
    setNextStep: bindActionCreators(setNextStep, dispatch),
    setCurrentStep: bindActionCreators(setCurrentStep, dispatch),
    fetchGlobalParameters: bindActionCreators(fetchGlobalParameters, dispatch),
    newAlert: bindActionCreators(newAlert, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterPromissory);
